import { useQuery } from '@tanstack/react-query'
import store from 'stores/store'
import { makeApiRequest } from '../apis/birdeye/helpers'
import { milliseconds } from 'date-fns'

export interface TokenOverview {
  address: string
  decimals: number
  symbol: string
  name: string
  marketCap: number | null
  fdv: number | null
  extensions: {
    coingeckoId: string | null
    serumV3Usdt: string | null
    website: string | null
    telegram: string | null
    twitter: string | null
    description: string | null
    github: string | null
    medium: string | null
    discord: string | null
    [key: string]: string | null
  }
  logoURI: string | null
  liquidity: number | null
  lastTradeUnixTime: number | null
  lastTradeHumanTime: string | null
  price: number | null
  history30mPrice: number | null
  priceChange30mPercent: number | null
  history1hPrice: number | null
  priceChange1hPercent: number | null
  history2hPrice: number | null
  priceChange2hPercent: number | null
  history4hPrice: number | null
  priceChange4hPercent: number | null
  history6hPrice: number | null
  priceChange6hPercent: number | null
  history8hPrice: number | null
  priceChange8hPercent: number | null
  history12hPrice: number | null
  priceChange12hPercent: number | null
  history24hPrice: number | null
  priceChange24hPercent: number | null
  uniqueWallet30m: number | null
  uniqueWalletHistory30m: number | null
  uniqueWallet30mChangePercent: number | null
  uniqueWallet1h: number | null
  uniqueWalletHistory1h: number | null
  uniqueWallet1hChangePercent: number | null
  uniqueWallet2h: number | null
  uniqueWalletHistory2h: number | null
  uniqueWallet2hChangePercent: number | null
  uniqueWallet4h: number | null
  uniqueWalletHistory4h: number | null
  uniqueWallet4hChangePercent: number | null
  uniqueWallet8h: number | null
  uniqueWalletHistory8h: number | null
  uniqueWallet8hChangePercent: number | null
  uniqueWallet24h: number | null
  uniqueWalletHistory24h: number | null
  uniqueWallet24hChangePercent: number | null
  totalSupply: number | null
  circulatingSupply: number | null
  holder: number | null
  trade30m: number | null
  tradeHistory30m: number | null
  trade30mChangePercent: number | null
  sell30m: number | null
  sellHistory30m: number | null
  sell30mChangePercent: number | null
  buy30m: number | null
  buyHistory30m: number | null
  buy30mChangePercent: number | null
  v30m: number | null
  v30mUSD: number | null
  vHistory30m: number | null
  vHistory30mUSD: number | null
  v30mChangePercent: number | null
  vBuy30m: number | null
  vBuy30mUSD: number | null
  vBuyHistory30m: number | null
  vBuyHistory30mUSD: number | null
  vBuy30mChangePercent: number | null
  vSell30m: number | null
  vSell30mUSD: number | null
  vSellHistory30m: number | null
  vSellHistory30mUSD: number | null
  vSell30mChangePercent: number | null
  trade1h: number | null
  tradeHistory1h: number | null
  trade1hChangePercent: number | null
  sell1h: number | null
  sellHistory1h: number | null
  sell1hChangePercent: number | null
  buy1h: number | null
  buyHistory1h: number | null
  buy1hChangePercent: number | null
  v1h: number | null
  v1hUSD: number | null
  vHistory1h: number | null
  vHistory1hUSD: number | null
  v1hChangePercent: number | null
  vBuy1h: number | null
  vBuy1hUSD: number | null
  vBuyHistory1h: number | null
  vBuyHistory1hUSD: number | null
  vBuy1hChangePercent: number | null
  vSell1h: number | null
  vSell1hUSD: number | null
  vSellHistory1h: number | null
  vSellHistory1hUSD: number | null
  vSell1hChangePercent: number | null
  trade2h: number | null
  tradeHistory2h: number | null
  trade2hChangePercent: number | null
  sell2h: number | null
  sellHistory2h: number | null
  sell2hChangePercent: number | null
  buy2h: number | null
  buyHistory2h: number | null
  buy2hChangePercent: number | null
  v2h: number | null
  v2hUSD: number | null
  vHistory2h: number | null
  vHistory2hUSD: number | null
  v2hChangePercent: number | null
  vBuy2h: number | null
  vBuy2hUSD: number | null
  vBuyHistory2h: number | null
  vBuyHistory2hUSD: number | null
  vBuy2hChangePercent: number | null
  vSell2h: number | null
  vSell2hUSD: number | null
  vSellHistory2h: number | null
  vSellHistory2hUSD: number | null
  vSell2hChangePercent: number | null
  trade4h: number | null
  tradeHistory4h: number | null
  trade4hChangePercent: number | null
  sell4h: number | null
  sellHistory4h: number | null
  sell4hChangePercent: number | null
  buy4h: number | null
  buyHistory4h: number | null
  buy4hChangePercent: number | null
  v4h: number | null
  v4hUSD: number | null
  vHistory4h: number | null
  vHistory4hUSD: number | null
  v4hChangePercent: number | null
  vBuy4h: number | null
  vBuy4hUSD: number | null
  vBuyHistory4h: number | null
  vBuyHistory4hUSD: number | null
  vBuy4hChangePercent: number | null
  vSell4h: number | null
  vSell4hUSD: number | null
  vSellHistory4h: number | null
  vSellHistory4hUSD: number | null
  vSell4hChangePercent: number | null
  trade8h: number | null
  tradeHistory8h: number | null
  trade8hChangePercent: number | null
  sell8h: number | null
  sellHistory8h: number | null
  sell8hChangePercent: number | null
  buy8h: number | null
  buyHistory8h: number | null
  buy8hChangePercent: number | null
  v8h: number | null
  v8hUSD: number | null
  vHistory8h: number | null
  vHistory8hUSD: number | null
  v8hChangePercent: number | null
  vBuy8h: number | null
  vBuy8hUSD: number | null
  vBuyHistory8h: number | null
  vBuyHistory8hUSD: number | null
  vBuy8hChangePercent: number | null
  vSell8h: number | null
  vSell8hUSD: number | null
  vSellHistory8h: number | null
  vSellHistory8hUSD: number | null
  vSell8hChangePercent: number | null
  trade24h: number | null
  tradeHistory24h: number | null
  trade24hChangePercent: number | null
  sell24h: number | null
  sellHistory24h: number | null
  sell24hChangePercent: number | null
  buy24h: number | null
  buyHistory24h: number | null
  buy24hChangePercent: number | null
  v24h: number | null
  v24hUSD: number | null
  vHistory24h: number | null
  vHistory24hUSD: number | null
  v24hChangePercent: number | null
  vBuy24h: number | null
  vBuy24hUSD: number | null
  vBuyHistory24h: number | null
  vBuyHistory24hUSD: number | null
  vBuy24hChangePercent: number | null
  vSell24h: number | null
  vSell24hUSD: number | null
  vSellHistory24h: number | null
  vSellHistory24hUSD: number | null
  vSell24hChangePercent: number | null
  numberMarkets: number | null
}

export const fetchBirdeyeTokenOverview = async (mint: string | undefined) => {
  if (!mint) {
    return undefined
  }

  try {
    const query = `defi/token_overview?address=${encodeURIComponent(mint)}`
    const overview = await makeApiRequest<TokenOverview>(query)
    return overview?.data ?? undefined
  } catch (e) {
    console.error('failed to fetch birdeye token overview', e)
    return undefined
  }
}

export const useBirdeyeTokenOverview = () => {
  const mint = store((s) => s.market.baseToken.mint)
  return useQuery({
    queryKey: ['birdeye-token-overview', mint],
    queryFn: () => fetchBirdeyeTokenOverview(mint),
    cacheTime: milliseconds({ minutes: 15 }),
    staleTime: milliseconds({ minutes: 10 }),
    retry: 3,
    enabled: !!mint,
    refetchOnWindowFocus: false,
  })
}
